import { PointArray } from './attribute'
import { ArcballState } from './controls'

export interface CameraProfileState {
  arcballState: ArcballState
}

/**
 * Camera view orientation.
 */
export enum CameraViewOrientation {
  FRONT = 'front',
  BACK = 'back',
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

/**
 * Camera profile data to orient the camera.
 */
export interface CameraProfile {
  target: PointArray
  state: CameraProfileState
  positions: Record<CameraViewOrientation, PointArray>
}

/**
 * Camera profile with only front position.
 */
export interface FrontCameraProfile extends Omit<CameraProfile, 'positions'> {
  positions: {
    front: PointArray
  }
}
